var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 324,
    viewBox: "0 0 600 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73438_26989)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2281 197.709L114.346 274.138C114.756 275.777 113.941 277.49 112.527 277.965C112.285 278.045 112.036 278.087 111.784 278.087H73.549C72.0762 278.087 70.8823 276.704 70.8823 274.998C70.8823 274.707 70.9178 274.418 70.9877 274.138L90.1054 197.709C90.5152 196.071 91.9942 195.128 93.4088 195.602C94.287 195.897 94.9736 196.692 95.2281 197.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6667 195.192L115.333 278.087H70L92.6667 195.192Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6665 201.943C92.6665 261.169 92.6665 291.441 92.6665 292.758C92.6665 291.441 92.6665 261.169 92.6665 201.943Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.333 239.978C96.2224 249.956 92.6668 255.104 92.6668 255.422C92.6668 255.104 96.2224 249.956 103.333 239.978Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.864 151.449L166.506 281.835C166.927 283.469 166.125 285.19 164.714 285.679C164.466 285.765 164.209 285.808 163.951 285.808H101.778C100.305 285.808 99.1108 284.425 99.1108 282.719C99.1108 282.42 99.1485 282.122 99.2225 281.835L132.864 151.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.667 151.449L167.333 285.808H98L132.667 151.449Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.667 155.444C132.667 245.695 132.667 291.981 132.667 294.302C132.667 291.981 132.667 245.695 132.667 155.444Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.197 216.312C127.086 227.244 131.531 232.907 131.531 233.3C131.531 232.907 127.086 227.244 118.197 216.312Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.197 256.465C146.642 239.599 152.864 231.362 152.864 231.756C152.864 231.362 146.642 239.599 134.197 256.465Z",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.667 259.554L455.333 200.869L411.333 241.022",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 227.123L411.333 214.768L368 256.465",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.282 298.108C201.634 288.147 193.259 281.18 183.511 281.18C180.826 281.18 178.244 281.709 175.837 282.683C171.268 274.489 163.423 269.083 154.511 269.083C145.988 269.083 138.44 274.028 133.801 281.629C131.945 280.354 129.789 279.624 127.49 279.624C125.477 279.624 123.575 280.183 121.887 281.177C117.33 267.411 106.013 257.663 92.7736 257.663C80.6173 257.663 70.0817 265.881 64.9113 277.883C61.8546 276.182 58.4416 275.232 54.8413 275.232C43.2494 275.232 33.5995 285.084 31.5298 298.108H205.282Z",
    fill: "#E5DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 295.847H190.667",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 295.847H600",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.63 298.163H363.191C363.103 297.026 363.058 295.874 363.058 294.709C363.058 273.867 377.44 256.971 395.182 256.971C400.057 256.971 404.679 258.247 408.818 260.53C415.82 244.418 430.087 233.384 446.548 233.384C464.476 233.384 479.801 246.471 485.973 264.953C488.258 263.618 490.835 262.867 493.56 262.867C496.674 262.867 499.593 263.847 502.106 265.558C508.388 255.355 518.609 248.716 530.151 248.716C547.116 248.716 561.228 263.059 564.171 281.981C565.041 281.82 565.933 281.737 566.842 281.737C575.214 281.737 582.178 288.82 583.63 298.163Z",
    fill: "#E5DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.667 295.846H594.667",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.333 240.25H396.667V218.629H248.667V240.25H310V272.681H347.333V240.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.333 217.856H185.333V239.477H249.333V217.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.748 240.183V272.947H346.567L347.764 241.227L396.667 240.183V323.645H250V240.548L309.748 240.183Z",
    fill: "#E5DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 240.25H186V323.645H250V240.25Z",
    fill: "#E5DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 218.629H396.667V323.645H250V218.629Z",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.667 240.25V218.629H250V240.25H310V272.681H347.333V240.25H396.667Z",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 181.564C150 202.034 164.327 218.629 182 218.629H195.333V144.5H182C164.327 144.5 150 161.094 150 181.564Z",
    fill: "#E5DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.833 151.406C169.897 150.681 158.582 158.94 150.889 176.185C150.407 177.265 149.958 178.262 149.543 179.176L150.812 171.212C151.304 169.865 152.121 167.647 153.263 164.559C159.62 155.79 163.024 151.406 163.474 151.406C163.924 151.406 167.029 149.461 172.788 145.571L179.079 144.419H184.833V151.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 181.564C150 202.034 164.327 218.629 182 218.629H195.333V144.5H182C164.327 144.5 150 161.094 150 181.564Z",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186 144.5H332.667V218.629H186V144.5Z",
    fill: "#E5DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186 144.5H332.667V218.629H186V144.5Z",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 240.25H186V323.645H250V240.25Z",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 218.629H186V240.25H250V218.629Z",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336 245.655C336 249.925 333.02 253.377 329.333 253.377C325.647 253.377 322.667 249.925 322.667 245.655C322.667 241.385 325.647 237.933 329.333 237.933C333.02 237.933 336 241.385 336 245.655Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.333 250.288V258.01",
    stroke: "#D2B9FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.667 259.554C264.876 259.554 266.667 257.48 266.667 254.921C266.667 252.362 264.876 250.288 262.667 250.288C260.457 250.288 258.667 252.362 258.667 254.921C258.667 257.48 260.457 259.554 262.667 259.554Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.667 313.607C264.876 313.607 266.667 311.532 266.667 308.974C266.667 306.415 264.876 304.341 262.667 304.341C260.457 304.341 258.667 306.415 258.667 308.974C258.667 311.532 260.457 313.607 262.667 313.607Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 259.554C386.209 259.554 388 257.48 388 254.921C388 252.362 386.209 250.288 384 250.288C381.791 250.288 380 252.362 380 254.921C380 257.48 381.791 259.554 384 259.554Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 313.607C386.209 313.607 388 311.532 388 308.974C388 306.415 386.209 304.341 384 304.341C381.791 304.341 380 306.415 380 308.974C380 311.532 381.791 313.607 384 313.607Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.333 259.554C239.543 259.554 241.333 257.48 241.333 254.921C241.333 252.362 239.543 250.288 237.333 250.288C235.124 250.288 233.333 252.362 233.333 254.921C233.333 257.48 235.124 259.554 237.333 259.554Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.333 313.607C239.543 313.607 241.333 311.532 241.333 308.974C241.333 306.415 239.543 304.341 237.333 304.341C235.124 304.341 233.333 306.415 233.333 308.974C233.333 311.532 235.124 313.607 237.333 313.607Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.667 259.554C200.876 259.554 202.667 257.48 202.667 254.921C202.667 252.362 200.876 250.288 198.667 250.288C196.457 250.288 194.667 252.362 194.667 254.921C194.667 257.48 196.457 259.554 198.667 259.554Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.667 313.607C200.876 313.607 202.667 311.532 202.667 308.974C202.667 306.415 200.876 304.341 198.667 304.341C196.457 304.341 194.667 306.415 194.667 308.974C194.667 311.532 196.457 313.607 198.667 313.607Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.572 292.445L441.333 323.674H417.333L428.095 292.445C428.368 291.653 429.144 291.267 429.828 291.583C430.167 291.74 430.436 292.051 430.572 292.445Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.572 304.052L451.333 323.674H435.333L442.095 304.052C442.368 303.26 443.144 302.874 443.828 303.19C444.167 303.347 444.436 303.659 444.572 304.052Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.095 292.445L155.333 323.674H179.333L168.572 292.445C168.299 291.653 167.523 291.267 166.839 291.583C166.5 291.74 166.231 292.051 166.095 292.445Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.095 304.052L137.333 323.674H153.333L146.572 304.052C146.299 303.26 145.523 302.874 144.839 303.19C144.5 303.347 144.231 303.659 144.095 304.052Z",
    fill: "#D2B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 323.645H540",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 323.645H510.667",
    stroke: "#D2B9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 73.4593H201.333C200.372 65.0771 202.775 58.0649 208.544 52.4227C215.167 46.131 223.031 47.5415 227.255 49.7125C231.478 51.8835 234.614 54.8663 236.788 60.4948C237.71 62.8646 238.336 64.8696 238.667 66.5097",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 78.0925C229.408 72.4497 232.297 68.7604 236.667 67.0245C243.223 64.4206 249.44 67.8883 251.923 71.3774C254.406 74.8665 255.193 77.6694 255.662 80.5945C255.974 82.5446 256.087 84.7993 256 87.3586C261.522 87.0982 265.225 88.3852 267.109 91.2195C269.387 94.6072 269.62 98.6596 268.791 101.644C267.961 104.628 265.193 108.98 260 108.98H154.667",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.333 88.9028H228.001",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.333 88.9028H128",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 25.5843H349.333C348.372 17.2021 350.775 10.1899 356.544 4.54771C363.167 -1.74396 371.031 -0.333455 375.255 1.83754C379.478 4.00854 382.614 6.9913 384.788 12.6198C385.71 14.9896 386.336 16.9946 386.667 18.6347",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 30.2175C377.408 24.5747 380.297 20.8854 384.667 19.1495C391.223 16.5456 397.44 20.0133 399.923 23.5024C402.406 26.9915 403.193 29.7944 403.662 32.7195C403.974 34.6696 404.087 36.9243 404 39.4836C409.522 39.2232 413.225 40.5102 415.109 43.3445C417.387 46.7322 417.62 50.7846 416.791 53.7689C415.961 56.7532 413.193 61.1046 408 61.1046H302.667",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.333 41.0278H376.001",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.333 41.0278H276",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.432 113.952C485.432 113.952 498.764 114.831 496.299 131.817",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.382 126.647C514.382 126.647 503.837 117.026 496.196 131.736",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.283 171.884C452.283 171.884 463.494 163.475 469.738 176.055",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.586 161.417C482.586 161.417 469.39 162.33 470.344 176.929",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.333 109.752V132.917",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.333 150.677H369.333",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.333 138.322L361.333 121.334",
    stroke: "#E5DAFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73438_26989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 323.674,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.e6de486596534231c9186abcac1d8b13.svg";
export { ForwardRef as ReactComponent };